import React from "react";
import { SunOutlined, MoonOutlined } from "@ant-design/icons";
import { Button } from "./button";
import { useTheme } from "../../contexts/ThemeContext";

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className="text-muted-foreground hover:text-foreground"
      aria-label={`Switch to ${theme === "light" ? "dark" : "light"} theme`}
      title={`Switch to ${theme === "light" ? "dark" : "light"} theme`}
    >
      {theme === "light" ? (
        <MoonOutlined className="w-5 h-5" />
      ) : (
        <SunOutlined className="w-5 h-5" />
      )}
    </Button>
  );
}; 